import React, { Component } from 'react';
import { filter, some } from 'lodash';
import { comparePrePropsAndNextProps, setDash } from '../../../../lib/common';
import { setDateFormat } from '../../../../lib/moment';
import Panel from '../../../../components/outline/Panel';
import CheckBox from '../../../../components/input/CheckBox';
import BaseForm from '../../../../components/form/BaseForm';
import Button from '../../../../components/Button';
import Img from '../../../../components/Img';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import './BrandTierSelectorList.scss';

class BrandTierSelectorList extends Component {
  /**
   *  Component 의 변경되는 props 와 state 가 있을 경우에만,
   *  render 메소드를 호출할 수 있도록 함
   */
  shouldComponentUpdate = (nextProps) => {
    return comparePrePropsAndNextProps([[nextProps, this.props]]);
  };

  render() {
    const { brandTierSelector, setData, addBrandTierListItem, checkIsDuplicateOnTierList } = this.props;
    const { list, selectedList, selectedTier } = brandTierSelector;

    return (
      <div className="brand-tier-selector-list">
        {list.map((item) => {
          return (
            <Panel
              className={`selector-card ${checkIsDuplicateOnTierList(item.storeId) ? 'selected' : ''}`}
              key={item.storeId}
            >
              <div className="panel-body">
                <div className="selector-card-header">
                  <CheckBox
                    checked={some(selectedList, ['storeId', item.storeId])}
                    disabled={checkIsDuplicateOnTierList(item.storeId)}
                    onChange={(checked) => {
                      /**
                       *  체크하면 리스트에 추가
                       */
                      if (checked) {
                        /**
                         *  selectedList 에 해당 브랜드 추가
                         */
                        setData({
                          path: ['brandTierSelector', 'selectedList', selectedList.length],
                          value: item,
                        });
                      } else {
                        /**
                         *  체크를 풀면 리스트에서 삭제
                         */
                        /**
                         *  selectedList 에 해당 브랜드 삭제
                         */
                        setData({
                          path: ['brandTierSelector', 'selectedList'],
                          value: filter(selectedList, (selectedItem) => selectedItem.storeId !== item.storeId),
                        });
                      }
                    }}
                  />

                  <label className="selector-card-header-label">{item.storeName}</label>

                  <Button
                    isRadius
                    color="primary"
                    text="직접 추가"
                    disabled={!selectedTier || checkIsDuplicateOnTierList(item.storeId)}
                    onClick={() => addBrandTierListItem(item)}
                  />
                </div>

                <div className="selector-card-content">
                  <div className="selector-card-img">
                    <Img src={item.url} />
                  </div>

                  <div className="selector-card-text">
                    <BaseForm
                      label="입점 일자"
                      content={setDateFormat(item.confirmDate, DATE_FORMAT.YMD_DASH_FORMAT)}
                    />

                    <BaseForm label="판매중인 제품 수" content={setDash(item.productCount)} />

                    <BaseForm label="브랜드 찜 수" content={setDash(item.likeCount)} />

                    <BaseForm label="메모" content={setDash(item.memo)} />

                    {item.tier && <BaseForm label="티어" content={setDash(item.tier)} />}
                  </div>
                </div>
              </div>
            </Panel>
          );
        })}
      </div>
    );
  }
}

export default BrandTierSelectorList;
